export default "__VITE_ASSET__5365e681__"